import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { SetColorsService } from 'core'

@Component({
  selector: 'bmprod-player',
  templateUrl: './bmprod-player.component.html',
  styleUrls: ['./bmprod-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmprodPlayerComponent implements OnInit {
  colorSettingsMode = false

  constructor(private setColorsService: SetColorsService) {}

  ngOnInit(): void {
    this.getColorSettingsMode()
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
